import React, { useState } from "react";
import { Form, Input, Button, Progress } from "antd";
import ReactCodeInput from "react-verification-code-input";
import Typography from "antd/es/typography";
import "./Code.css";

export const LoginCodeForm = ({
	loading,
	submitting,
	onFinish,
	onChange,
	failed,
	setVerificationCode,
	codeKey,
	backToLogin,
	retransmitVerificationCode,
	timer,
}) => {
	const validateStatus = failed ? "error" : null;
	const [verificationCodeComplete, setVerificationCodeComplete] = useState(true);
	const verifyCodeChange = (vals) => {
		if (vals.length >= 5) {
			setVerificationCodeComplete(false);
			setVerificationCode(vals);
		} else {
			setVerificationCodeComplete(true);
		}
	};
	return (
		<div>
			<Typography className="f-14 color-primary">کد ۵ رقمی ارسال شده به شماره {codeKey} را وارد کنید.</Typography>
			<Form onFinish={onFinish} onChange={onChange}>
				<Form.Item
					name="code"
					rules={[{ required: true }]}
					hasFeedback={failed}
					validateStatus={validateStatus}
				>
					{/*<Input placeholder="کد ورود" disabled={submitting} />*/}
					<div style={{ direction: "ltr", justifyContent: "center", display: "flex" }}>
						<ReactCodeInput
							fields={5}
							fieldWidth={58}
							className="verification-code-input-container"
							onChange={verifyCodeChange}
							inputStyle={{
								fontFamily: "monospace",
								margin: "4px",
								MozAppearance: "textfield",
								width: "15px",
								borderRadius: "3px",
								fontSize: "14px",
								height: "26px",
								paddingLeft: "7px",
								backgroundColor: "black !important",
								color: "lightskyblue",
								border: "1px solid lightskyblue",
							}}
						/>
					</div>
				</Form.Item>
				<Form.Item className="mb-1">
					<Button
						type="primary"
						htmlType="submit"
						block={true}
						loading={submitting}
						style={{ borderRadius: "5px" }}
						size="large"
					>
						ثبت کد
					</Button>
				</Form.Item>
			</Form>
			<div>
				<p className="f-16">
					کد را دریافت نکرده اید؟ &nbsp;
					{timer ? (
						<>
							<Progress
								style={{ padding: "0px 10px" }}
								type="circle"
								status="active"
								width={30}
								format={(value) => `${value} ثانیه`}
								percent={timer}
							/>
							<span>تا ارسال مجدد کد </span>
						</>
					) : (
						<a onClick={retransmitVerificationCode}>ارسال مجدد کد</a>
					)}
				</p>
			</div>
		</div>
	);
};
